'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shelfShape = _reactImmutableProptypes2.default.contains({
  userId: _react.PropTypes.number.isRequired,
  name: _react.PropTypes.string.isRequired,
  privateByDefault: _react.PropTypes.bool,
  items: _reactImmutableProptypes2.default.list.isRequired,
  pagination: _reactImmutableProptypes2.default.map.isRequired,
  sort: _reactImmutableProptypes2.default.map.isRequired,
  facets: _reactImmutableProptypes2.default.list.isRequired
});

exports.default = shelfShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/shelfShape.js
// module id = 305
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14